import React, { useState, useEffect } from "react";
import { giftCardService } from "../../services";
import { FaGift } from "react-icons/fa";

const GiftCardBanner = () => {
  const [isActive, setIsActive] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkConfig = async () => {
      try {
        const config = await giftCardService.getConfig();
        setIsActive(config.isActive);
      } catch {
        // Silently fail
      } finally {
        setLoading(false);
      }
    };
    checkConfig();
  }, []);

  if (loading || !isActive) return null;

  return (
    <section className="bg-primary py-16">
      <div className="container mx-auto px-4 text-center">
        <FaGift className="text-accent text-4xl mx-auto mb-4" />
        <h2 className="text-3xl md:text-4xl font-primary text-white mb-3">
          Regalá una experiencia en La Alameda
        </h2>
        <p className="text-white/60 text-lg mb-8 max-w-xl mx-auto font-secondary">
          Sorprendé a alguien especial con una Gift Card para disfrutar de
          una estadía única en nuestra estancia.
        </p>
        <a
          href="/gift-card"
          className="inline-block bg-accent text-white font-tertiary uppercase px-8 py-3 tracking-[3px] text-sm hover:opacity-80 transition-all duration-300"
        >
          Comprar Gift Card
        </a>
      </div>
    </section>
  );
};

export default GiftCardBanner;
